// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__dDwMU","tab":"style_tab__ZwU3o"};